<template>
  <div>
    <el-dialog :title="title" :width="width" append-to-body :visible.sync="show" :show-close="closed" @close="onClose" class="side-black-popup" :style="'padding:'+ padding" top="0">
      <div>
        <slot />
      </div>
      <div slot="footer" class="dialog-footer">
        <slot name="footer" />
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: 'SidePopup',
  props: {
    /**
     * 标题
     */
    title: {
      type: String,
      default: '加载中...'
    },
    padding: {
      type: String,
      default: '0 30px'
    },
    /**
         * 窗口是否允许关闭
         */
    popupVisible: {
      type: Boolean,
      default: false
    },
    /**
     * 窗口是否允许关闭
     */
    closed: {
      type: Boolean,
      default: true
    },
    /**
     * 窗口宽度，支持固定值和比例（比例使用小于等于1的数，如0.5标识宽度为window宽度*05）
     */
    width: {
      type: String,
      default: 'auto'
    }
  },
  data() {
    return {
      show: false
    }
  },

  watch: {
    popupVisible() {
      this.show = this.popupVisible
      if (this.popupVisible) {
        this.$nextTick(() => {
          const modal = document.querySelector('.v-modal');
          if (modal) {
            modal.style.backgroundColor = 'rgba(0, 0, 0, 0)'
            // modal.style.zIndex = '1200'
          }
        })
      }
    }
  },

  created() {
    this.show = this.popupVisible
    if (this.popupVisible) {
      this.$nextTick(() => {
        const modal = document.querySelector('.v-modal');
        if (modal) {
          modal.style.backgroundColor = 'rgba(0, 0, 0, 0)'
          // modal.style.zIndex = '1200'
        }
      })
    }
  },

  methods: {
    onClose() {
      this.$emit('onClose', 'onClose')
    }
  }
}
</script>

<style lang="less" scoped>
.side-black-popup {
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: rgba(21, 22, 71, 0.1);
}
.side-black-popup::after {
  width: 100%;
  height: 100%;
  display: block;
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  backdrop-filter: blur(20px);
  -webkit-backdrop-filter: blur(20px);
  z-index: -1;
}
::v-deep .el-dialog {
  border-radius: 6px;
  // width: auto;
  margin-bottom: 0 !important;
  max-width: 1000px;
  background: #101010;
  box-sizing: border-box;
  border: 2px solid #ffd700; /* 边框颜色为金色 */
  box-shadow: 0 0 2px #ffd700, /* 基础发光层 */ 0 0 10px #ffd700,
    /* 中间发光层 */ 0 0 20px rgba(255, 215, 0, 0.7); /* 最外层透明渐变 */
  .el-dialog__header {
    text-align: center;
    font-weight: bolder;
    font-size: 20px;
    padding: 0;
    line-height: 50px;
  }
  .el-dialog__title {
    color: #fff;
  }
  .el-dialog__headerbtn {
    top: 0;
    right: 0;
    // line-height: 50px;
    padding: 11px 20px;
    .el-icon-close {
      color: #fff;
      font-weight: bold;
      font-size: 28px;
    }
  }
  .el-dialog__body {
    padding: 0;
    max-height: calc(90vh - 120px);
    overflow-y: auto;
    padding: 0 15px;
  }
  .el-dialog__footer {
    padding: 0;
    text-align: center;
  }
}
</style>
<style>
/* 整个滚动条 */
.side-black-popup ::-webkit-scrollbar {
  width: 6px; /* 滚动条的宽度 */
  height: 6px; /* 滚动条的高度 */
}

/* 滚动条轨道 */
.side-black-popup ::-webkit-scrollbar-track {
  background: #101010; /* 轨道颜色 */
}

/* 滚动条滑块 */
.side-black-popup ::-webkit-scrollbar-thumb {
  background: #888; /* 滑块颜色 */
  border-radius: 6px; /* 滑块圆角 */
}

/* 滑块悬停时 */
.side-black-popup ::-webkit-scrollbar-thumb:hover {
  background: #555; /* 滑块悬停时的颜色 */
}
.el-popup-parent--hidden {
  padding-right: 0 !important;
}
</style>